export interface GetSlideDaysRequest {
  branchCode: string
  year: string
  month: string
}

export function GetSlideDaysRequestFromJSON(value: GetSlideDaysRequest): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined
  }
}
